import siteConfig from '@/config/site';

/** Format minor-unit price (cents) into a localized currency string. */
export function formatPrice(priceCents: number, currency = siteConfig.currency): string {
  return new Intl.NumberFormat(siteConfig.locale.replace('_', '-'), {
    style: 'currency',
    currency,
  }).format(priceCents / 100);
}

/** Parse a user-entered price string (e.g. "19.99") into cents. */
export function parsePriceToCents(value: string): number {
  const n = Number.parseFloat(value.replace(',', '.'));
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}
